module.exports = __webpack_public_path__ + "img/coach-plan.427ee5f4.svg";